import styled from 'styled-components';

import { COLORS } from '@avalara/bat-apps-shared/constants';

export const PasswordStrengthBox = styled.div`
margin-top: 1rem;
  
.strength-meter {
  height: 10px;

  &#strength-meter-container {
    background-color: ${COLORS.lighterGray};
  }

  &#strength-meter-gauge {
    &.weak {
      width: 15%;
      background-color: #C70000;
    }

    &.okay {
      width: 40%;
      background-color: #FEDB4F;
    }

    &.good {
      width: 70%;
      background-color: #22AE36;
    }

    &.great {
      width: 100%;
      background-color: #22AE36;
    }

    &.strength {
      width: 0%;
    }
  }
}

.strength-text {
  margin-top: 4px;
  color: ${COLORS.mediumGray};

  &.weak {
    color: #C70000;
  }

  &.okay {
    color: ${COLORS.mediumDarkGray};
  }

  &.good {
    color: #22AE36;
  }

  &.great {
    color: #22AE36;
  }

  &.strength {
    color: transparent;
  }
`;
